import { AlertCircle } from "lucide-react";
import { Card, CardDescription, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils/common";

interface ErrorCardProps {
  title: string;
  description: string;
  className?: string;
}

export function ErrorCard({ title, description, className }: ErrorCardProps) {
  return (
    <Card className={cn("p-4 bg-red-50 flex flex-col flex-grow", className)}>
      <div className="flex flex-col items-center justify-center text-center h-full">
        <div className="p-4 inline-flex items-center justify-center">
          <AlertCircle className="h-8 w-8 text-red-600" />
        </div>
        <CardTitle className="text-red-600 py-2">{title}</CardTitle>
        <CardDescription className="text-red-600">
          <pre className="whitespace-pre-wrap break-words max-w-full">{description}</pre>
        </CardDescription>
      </div>
    </Card>
  );
}
